import * as React from "react";
import { DomainDraftInitializer } from "./draftInitializer";

interface Props {}
export const DomainDraft: React.FC<Props> = () => {
  return <DomainDraftInitializer />;
};
